import React from "react";
import { graphql } from "gatsby";
import { injectIntl, Link } from "gatsby-plugin-intl";
import Img from "gatsby-image";
import Layout from "../components/layout/Layout";
import Section from "../components/section/Section";
import PageTitle from "../components/page-title/PageTitle";
import Grid from "../components/grid/Grid";
import ArrowLink from "../components/links/ArrowLink";
import AppSnippet from "../lib/AppSnippet";
import cssClass from "./find-your-clinic.module.scss";

const OurClinics = ({ data }) => {
  const renderClinics = data.allContentfulClinic.nodes.map(
    ({ id, name, slug, image, phone, address, city }) => {
      const path = `/${slug}`;

      return (
        <div key={id} className={cssClass.clinic}>
          <Link to={path}>
            <Img
              fluid={image.fluid}
              alt={image.title}
              className={cssClass.image}
            />
          </Link>
          {city && <div className={cssClass.city}>{city}</div>}
          <h2 className={cssClass.name}>
            <Link to={path}>{name}</Link>
          </h2>
          <p className={cssClass.phone}>{phone}</p>
          <div
            dangerouslySetInnerHTML={{
              __html: address.childMarkdownRemark.html,
            }}
            className={cssClass.address}
          />
          <ArrowLink to={path}>
            <AppSnippet snippet="callToActionLink" />
          </ArrowLink>
        </div>
      );
    }
  );

  const { pageTitle, contentHeader } = data.contentfulFindYourClinicPage;

  return (
    <Layout navInvert>
      <PageTitle title={pageTitle} />
      <Section verticalPadding>
        <h2 className={cssClass.title}>{contentHeader}</h2>
        <Grid columns={3}>{renderClinics}</Grid>
      </Section>
    </Layout>
  );
};

export const query = graphql`
  query ContentFulClinics($locale: String) {
    allContentfulClinic(filter: { node_locale: { eq: $locale } }) {
      nodes {
        id
        name
        slug
        image {
          title
          fluid {
            ...GatsbyContentfulFluid_withWebp
          }
        }
        phone
        city
        address {
          childMarkdownRemark {
            html
          }
        }
      }
    }
    contentfulFindYourClinicPage(node_locale: { eq: $locale }) {
      pageTitle
      contentHeader
    }
  }
`;

export default injectIntl(OurClinics);
